module.exports = __webpack_public_path__ + "img/tribus-footer-logo.57b4b457.png";